
export function checkPlatform (platformType) {
  if (platformType == 'rep-quote') {
   return false
  } else {
   return true
  }
}

export function isRedirectedFromReview () {
  return (localStorage.getItem("navto")!=='review')
}